<template>
  <div id="demo-chart-bag">
    <div id="energyChart">
      <div id="legend"></div>
      <div id="totalValue">
        累積耗電量：<p></p>
      </div>
    </div>
  </div>
</template>

<script>
import createCircularBar from '../library/createCircularBar';
import createPieChar from '../library/createPie';
import { axiosMixins } from './mixins/axiosErrorMessage';

export default {
  mixins: [axiosMixins],
  data() {
    return {
      region_data: [],
      legend_array: [
        ["red", "Peak"],
        ["yellow", "Moderate"],
        ["gray", "Off-peak"],
      ],
      request_date: "2024-01-16",
      cumulative_data: []
    }
  },
  mounted() {
    this.getBxData();
  },
  methods: {
    getCircuitsData() {
      const cumulative_data = this.cumulative_data;
      this.createPie(cumulative_data);
      this.createCircularBar(cumulative_data);
      this.createTotalValue(cumulative_data);

      const body = document.getElementById('demo-chart-bag');
      const textElements = document.getElementsByTagName('text');
      const backgroundColor = window.getComputedStyle(body, null).getPropertyValue('background-color');
      const rgb = backgroundColor.match(/\d+/g);
      const brightness = (parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) / 1000;

      // 如果背景顏色亮度小於 128，表示是深色，修改文字顏色為淺色
      if (brightness < 128) {
        body.style.color = '#AAAAAA';
        for (let i = 0; i < textElements.length; i++) {
          for (let j = 0; j < textElements.length; j++) {
            textElements[j].setAttribute('fill', '#AAAAAA');
          }
        }
      }
    },
    // 總電量外圍顯示用量狀態
    createPie(data) {
      const sortedKWhValues = data
        .map((entry) => entry.kWh)
        .sort((a, b) => a - b);
      const Q2 = sortedKWhValues[Math.floor(sortedKWhValues.length / 2)];
      const Q3 = sortedKWhValues[Math.floor((3 * sortedKWhValues.length) / 4)];

      // 設置顏色
      data.forEach((entry) => {
        if (entry.kWh < 1 || entry.kWh < Q2) {
          entry.color = this.legend_array[2][0];
        } else if (entry.kWh < Q3) {
          entry.color = this.legend_array[1][0];
        } else {
          entry.color = this.legend_array[0][0];
        }
      });

      const height = parseInt(d3.select('#energyChart').style("height"), 10);
      document.getElementById('energyChart').style.width = height + "px";
      const createPie = {
        data: data,
        width: height,
        height: height,
        radius: height / 2,
        innerRadius: height * 0.38,
        legendItemSize: 12,
        legendSpacing: 4,
        legend_array: this.legend_array
      }

      createPieChar(createPie);
    },
    // 總電量圓形條狀圖
    createCircularBar(data) {
      const height = parseInt(d3.select('#energyChart').style("height"), 10);
      const margin = height * 0.26
      const createCircularBarParams = {
        data: data,
        width: height,
        height: height,
        innerRadius: height * 0.13,
        outerRadius: (height - margin) / 2,
        dataColumns: ["kWh"],
      }

      createCircularBar(createCircularBarParams);
    },
    // 耗電量總計
    createTotalValue(data) {
      const showValue = Math.max(...data.map(item => {
        return item.cumulative_ep;
      }).filter(d => d))

      // 依渲染圖表大小，設定總耗電量字型大小
      const height = parseInt(d3.select('#energyChart').style("height"), 10);
      document.getElementById('totalValue').style.fontSize = height / 600 + "rem"
      document.getElementById("totalValue").querySelector("p").innerText = Math.round(showValue * 10) / 10 + " kWh";
    },
    getBxData() {
      axios.get(base_url + "/api/regions/")
        .then((response) => {
          this.region_data.mac = response.data[0].bx_meters[0].bx_mac
          this.region_data.circuit_id = response.data[0].bx_meters[0].bx_circuits[0].id
          this.getBxLog()
        }).catch((error) => {
          this.axiosMessage(error);
        });
    },
    getBxLog() {
      let date = new Date();

      const getBxLog = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        circuit_id: this.region_data.circuit_id,
        mac: this.region_data.mac,
      }

      axios.post(base_url + '/api/bx/log/day', getBxLog)
        .then((response) => {
          this.cumulative_data = response.data.cumulative_data;
          this.getCircuitsData();
        }).catch((error) => {
          this.axiosMessage(error);
        });
    }
  },
}
</script>

<style>
#demo-chart-bag {
  background-color: #1a1f1f;
}

#demo-chart-bag {
  display: flex;
  justify-content: center;
  height: 100vh;
}

#energyChart {
  position: relative;
  max-width: 600px;
  max-height: 600px;
  display: flex;
}

#legend {
  position: absolute;
  right: 0;
  bottom: 50px;
}

#totalValue {
  line-height: 1rem;
  height: 30px;
}
</style>
